export default "__VITE_ASSET__eZzrmifN__"